<template v-if="subsection">
  <section
    :class="[
      'container subsection',
      'subsection__' + subsection.type,
      subsection.type,
    ]"
  >
    <!-- Subsection header -->
    <div class="row" v-if="!$root.documentsOpen">
      <div class="col">
        <div class="section__header gsap-fade">
          <p class="section-title" v-if="!teamSubsection">
            0{{ section.index }}. {{ subsection.parentSlug }} -
          </p>

          <template v-if="subsection.type == 'sponsors'">
            <p class="subsection-title">Sponsors principaux</p>
            <h1 class="subsection-main-title">Sponsors principaux</h1>
          </template>
          <template v-else-if="teamSubsection && teamSubsection.type">
            <p class="section-title">
              0{{ section.index }}. {{ teamSection.title }} -
            </p>

            <p
              class="subsection-title"
              :class="{ inactive: $root.juniorsSubCategory }"
              @click="$root.juniorsSubCategory = null"
            >
              {{ teamSubsection.name }}
            </p>
            <p class="subsection-title" v-if="$root.juniorsSubCategory">
              / {{ $root.juniorsSubCategory.name }}
            </p>

            <transition name="fade">
              <h1 class="subsection-main-title" v-if="$root.juniorsSubCategory">
                {{ $root.juniorsSubCategory.name }}
              </h1>
              <h1 class="subsection-main-title" v-else>
                {{ teamSubsection.name }}
              </h1>
            </transition>
          </template>
          <template v-else>
            <p class="subsection-title">{{ subsection.title }}</p>
            <h1 class="subsection-main-title">{{ subsection.title }}</h1>
          </template>
        </div>
      </div>
    </div>

    <!--
			Club - History
		-->
    <div
      v-if="subsection.type == 'history' || subsection.type == 'raiffeisen_lfc'"
      class="row"
    >
      <div class="col gsap-fade-up">
        <div
          class="row"
          v-if="subsection.fields.image && subsection.fields.image.value.length"
        >
          <div class="col">
            <div
              class="section__fullscreen-bg"
              :style="{
                backgroundImage:
                  'url(' + medium(subsection.fields.image.value[0]) + ')',
              }"
            ></div>
          </div>
        </div>
        <div class="row section__white-bg">
          <div class="col-lg-8">
            <div
              class="section__content-description"
              v-html="subsection.content"
            ></div>
          </div>
          <div class="col-lg-8 col-xl-4 col-no-padding">
            <a
              v-for="pdf in subsection.collections[0].pages"
              :href="'/uploads/' + pdf.fields.pdf_file.value[0]"
              target="_blank"
              class="component__pdf"
              v-if="
                subsection &&
                  subsection.collections &&
                  subsection.collections.length
              "
            >
              <div class="component__pdf__img-block">
                <img src="/images/pdf-icon.svg" alt="" />
              </div>
              <div class="component__pdf-description">
                <p>{{ pdf.title }}</p>
                <span>Télécharger</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--
			Club - Honor Members
		-->
    <div v-if="subsection.type == 'honor_members'" class="row">
      <div class="col main-leagues">
        <div class="row gsap-fade-up">
          <div class="col">
            <div
              class="component__fullscreen-bg"
              :style="{
                'background-image':
                  'url(' + medium(subsection.fields.image.value[0]) + ')',
              }"
            ></div>
          </div>
        </div>
        <div class="row section__white-bg">
          <div class="col">
            <div class="row">
              <div class="col">
                <p class="teams__league-season"></p>
                <p class="teams__league-name">Président d'honneur</p>
              </div>
            </div>
            <div class="row relative">
              <div class="col-lg-12 main-leagues__players-block">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <div
                        class="col-xl-4 col-md-6 col-sm-12"
                        v-for="page in subsection.collections[0].pages"
                        :key="page.id"
                      >
                        <div class="teams__league-player">
                          <div class="info">
                            <p class="position">Président d'honneur</p>
                            <p class="name">{{ page.title }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="teams__league-season"></p>
                <p class="teams__league-name">Membre d'honneur</p>
              </div>
            </div>
            <div class="row relative">
              <div class="col-lg-12 main-leagues__players-block">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <div
                        class="col-xl-4 col-md-6 col-sm-12"
                        v-for="page in subsection.collections[1].pages"
                        :key="page.id"
                      >
                        <div class="teams__league-player">
                          <div class="info">
                            <p class="position">Membre d'honneur</p>
                            <p class="name">{{ page.title }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Club - Nos arbitres -->
    <div
      v-else-if="subsection.type == 'our_referees'"
      class="row background-white"
    >
      <div class="col">
        <div class="row">
          <div class="col">
            <p class="our_referees__season"></p>
            <p
              class="our_referees__subtitle"
              v-if="subsection.fields.sub_title.value"
            >
              {{ subsection.fields.sub_title.value }}
            </p>
          </div>
        </div>
        <div class="row">
          <div
            class="col-lg-4 gsap-fade-up"
            v-for="page in subsection.collections[0].pages"
          >
            <div class="our_referees__page">
              <h1>{{ page.title }}</h1>
              <div v-html="page.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--
			Club - Infrastrucutre
		-->
    <div
      v-else-if="subsection.type == 'infrastructure'"
      class="row background-white"
    >
      <div class="col-lg-8 gsap-fade-on-change" v-if="stadium">
        <div class="row gsap-fade">
          <div class="col">
            <swiper
              :options="sliderOptions"
              ref="mySwiper"
              class="infrastructure__gallery"
            >
              <swiper-slide
                class="image"
                v-for="(img, index) in stadium.fields.gallery.value"
                :style="{ backgroundImage: 'url(/uploads/' + img + ')' }"
                :key="index"
              >
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
        </div>
        <div class="row gsap-fade">
          <div class="col">
            <div class="component__page-description">
              <h6 class="subtitle">{{ subsection.title }}</h6>
              <h1 class="title">{{ stadium.title }}</h1>
              <div v-html="stadium.content"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="row">
          <div class="col">
            <ul class="infrastructure__pages-list">
              <li
                v-for="page in subsection.collections[0].pages"
                @click="viewStadium(page)"
              >
                <div
                  v-if="page.fields.gallery && page.fields.gallery.value"
                  class="img"
                  :style="{
                    backgroundImage:
                      'url(' + thumbnail(page.fields.gallery.value[0]) + ')',
                  }"
                ></div>
                <div class="content">
                  <h6>{{ page.title }}</h6>
                  <span>Plus d’info</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--
			Club - Pratiques
		-->
    <div
      v-else-if="subsection.type == 'organization'"
      class="row background-white gsap-fade-up"
    >
      <div class="col">
        <div class="row organization__logo-block">
          <div class="col"><img src="/images/lfc-logo.svg" alt="" /></div>
        </div>
        <!-- Category -->
        <div
          class="row category-row"
          v-for="category in subsection.collections"
        >
          <div class="col-lg-6 col-xl-4" v-for="page in category.pages">
            <div class="organization__category-page">
              <div
                class="organization__image"
                v-if="
                  page.fields && page.fields.image && page.fields.image.value
                "
                :style="{
                  'background-image':
                    'url(' + thumbnail(page.fields.image.value[0]) + ')',
                }"
              ></div>
              <div class="organization__content">
                <h6>{{ page.title }}</h6>
                <div v-html="page.content" class="name"></div>
                <div
                  v-if="
                    page.fields &&
                      page.fields.contact_info &&
                      page.fields.contact_info.value
                  "
                  v-html="page.fields.contact_info.value"
                  class="contact-info"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--
			Club - Informations pratiques
		-->
    <div
      v-else-if="subsection.type == 'useful_information'"
      class="background-white gsap-fade-up"
    >
      <div class="row category-row" v-for="category in subsection.collections">
        <div class="grid">
          <div class="grid-sizer"></div>
          <div
            class="useful_information__category-page grid-item"
            v-for="page in category.pages"
          >
            <div>
              <h6>{{ page.title }}</h6>
              <div v-html="page.content"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <next-matches-component></next-matches-component>
      </div>
    </div>

    <!-- 
			Club - Contact
		 -->
    <div class="row contact-row" v-else-if="subsection.type == 'contact'">
      <div class="col-xl-8">
        <div class="contact__stadium">
          <div class="contact__map">
            <gmap-map
              :center="{
                lat: parseFloat(selectedStadiumInfo.fields.latitude.value),
                lng: parseFloat(selectedStadiumInfo.fields.longitude.value),
              }"
              :zoom="map.zoom"
              :tilt="map.tilt"
              :map-type-id="map.type"
              :options="map.options"
              style="width: 100%; height: 100%"
            >
              <gmap-marker
                :position="{
                  lat: parseFloat(selectedStadiumInfo.fields.latitude.value),
                  lng: parseFloat(selectedStadiumInfo.fields.longitude.value),
                }"
                :clickable="false"
                :draggable="false"
                :icon="'/uploads/' + subsection.fields.map_pin.value[0]"
              ></gmap-marker>
            </gmap-map>
          </div>
          <div class="contact__stadium-description">
            <h1 class="title">{{ selectedStadiumInfo.title }}</h1>
            <div
              class="route-location"
              v-html="selectedStadiumInfo.content"
            ></div>

            <div
              v-if="
                selectedStadiumInfo.fields.contact_info.value &&
                  selectedStadiumInfo.fields.contact_info.value.length
              "
              class="contact-info"
              v-html="selectedStadiumInfo.fields.contact_info.value"
            ></div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 contact__sidebar">
        <ul>
          <li
            v-for="(std, index) in subsection.collections[0].pages"
            @click="getStadiumInfo(std)"
          >
            <div
              class="contact__sidebar-img"
              v-if="std.fields.image.value && std.fields.image.value.length"
              :style="{
                backgroundImage:
                  'url(' + thumbnail(std.fields.image.value[0]) + ')',
              }"
            ></div>
            <div class="contact__sidebar-description">
              <h6>{{ std.title }}</h6>
              <div
                class="street-info"
                v-if="std.fields.contact_info.value"
                v-html="std.content"
              ></div>
              <div class="view-location">
                <img src="/images/pin.svg" alt="" />
                <p>Voir sur la carte</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!--
			News - Dernières news
		-->
    <div v-else-if="subsection.type == 'latest_news'" class="row">
      <div class="col">
        <div class="row">
          <highlight-news-component
            @allNews="handleNews"
            @yearsWithMonths="handleNewsMonths"
          ></highlight-news-component>
        </div>

        <template v-for="newsYear in newsCorrectOrder">
          <div
            class="row gsap-fade"
            v-for="(innerKey) in Object.keys(allNewsWithMonths[newsYear]).reverse()"
          >
            <div class="latest_news__year col">
              <div class="row">
                <div class="col">
                  <div class="component__red-banner" :id="newsYear">
                    <p>{{ innerKey | monthName }}</p>
                    <p>{{ newsYear }}</p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div
                  class="col-lg-6 col-xl-4"
                  v-for="page in allNewsWithMonths[newsYear][innerKey].reverse()"
                >
                  <router-link
                    :to="{
                      name: 'page',
                      params: {
                        sectionSlug: 'news',
                        subsectionSlug: 'dernieres-news',
                        pageSlug: page.slug,
                      },
                    }"
                    class="latest_news__thumbnail-page"
                  >
                    <div
                      class="img"
                      v-if="
                        page.fields.image.value &&
                          page.fields.image.value.length
                      "
                      :style="{
                        backgroundImage:
                          'url(' + thumbnail(page.fields.image.value[0]) + ')',
                      }"
                    ></div>
                    <div class="content">
                      <span>{{
                        page.fields.news_date.value | dateFormat
                      }}</span>
                      <h6>{{ page.title }}</h6>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!--
			Medias - Documents
		-->
    <div v-else-if="subsection.type == 'documents'" class="row">
      <div
        class="col-lg-4 gsap-fade-up"
        v-for="(pdf, index) in subsection.collections[0].pages"
        :key="index"
        v-if="
          subsection && subsection.collections && subsection.collections.length
        "
      >
        <a
          :href="
            pdf.fields.pdf_file.value && pdf.fields.pdf_file.value.length > 0
              ? '/uploads/' + pdf.fields.pdf_file.value[0]
              : ''
          "
          target="_blank"
          :class="{
            'events-none': !(
              pdf.fields.pdf_file.value && pdf.fields.pdf_file.value.length > 0
            ),
          }"
          class="component__pdf"
        >
          <div class="component__pdf__img-block">
            <img src="/images/pdf-icon.svg" alt="" />
          </div>
          <div class="component__pdf-description">
            <p>{{ pdf.title }}</p>
            <span>En savoir plus</span>
          </div>
        </a>
      </div>
    </div>

    <!--
			Medias - Documents
		-->
    <div v-else-if="subsection.type == 'photos_videos'" class="row">
      <div
        class="col-lg-4 gsap-fade-up"
        v-if="
          subsection && subsection.collections && subsection.collections.length
        "
        v-for="gallery in subsection.collections[0].pages"
      >
        <router-link
          v-if="!gallery.fields.link"
          class="component__pdf"
          :to="{
            name: 'page',
            params: {
              sectionSlug: section.slug,
              subsectionSlug: subsection.slug,
              pageSlug: gallery.slug,
            },
          }"
        >
          <div
            v-if="
              gallery.fields.gallery_images &&
                gallery.fields.gallery_images.value
            "
            class="component__pdf__img-block"
            :style="{
              backgroundImage:
                'url(' +
                thumbnail(gallery.fields.gallery_images.value[0]) +
                ')',
            }"
          ></div>
          <div class="component__pdf-description">
            <span
              class="date"
              v-if="gallery.fields.date && gallery.fields.date.value"
              >{{ gallery.fields.date.value }}</span
            >
            <p>{{ gallery.title }}</p>
          </div>
        </router-link>
        <a
          v-if="gallery.fields.link"
          class="component__pdf video-view"
          :href="gallery.fields.link.value"
          target="_blank"
        >
          <div
            v-if="
              gallery.fields.image &&
                gallery.fields.image.value &&
                gallery.fields.image.value.length
            "
            class="component__pdf__img-block"
            :style="{
              backgroundImage:
                'url(' + thumbnail(gallery.fields.image.value[0]) + ')',
            }"
          >
            <img src="/images/play.svg" alt="" />
          </div>
          <div class="component__pdf-description">
            <span
              class="date"
              v-if="gallery.fields.date && gallery.fields.date.value"
              >{{ gallery.fields.date.value }}</span
            >
            <p>{{ gallery.title }}</p>
            <span>Regarder</span>
          </div>
        </a>
      </div>
    </div>

    <!--
			 PARTENAIRES - Sponsors
		-->
    <div v-else-if="subsection.type == 'sponsors'" class="row">
      <div
        class="col"
        v-if="subsection.collections && subsection.collections.length"
      >
        <div class="row gsap-fade-up">
          <div
            class="col-lg-6 col-xl-4"
            v-for="sponsor in subsection.collections[0].pages"
            v-if="sponsor.fields.main_sponsor.value == 1"
          >
            <a
              target="_blank"
              :href="sponsor.fields.link.value || ''"
              :class="{ 'disable-click': sponsor.fields.link.value == '' }"
              class="sponsors__block sponsors__block--main"
            >
              <div class="img__block">
                <img
                  v-if="sponsor.fields.logo && sponsor.fields.logo.value.length"
                  :src="'/uploads/' + sponsor.fields.logo.value[0]"
                  alt=""
                />
              </div>
              <div class="body">
                <div
                  v-if="sponsor.content"
                  class="content"
                  v-html="sponsor.content"
                ></div>
                <span v-if="sponsor.fields.link && sponsor.fields.link.value"
                  >En savoir plus</span
                >
              </div>
            </a>
          </div>
        </div>

        <div class="row gsap-fade-up">
          <div class="col">
            <div class="row">
              <div class="col">
                <div class="section__header">
                  <h1 class="subsection-main-title">{{ subsection.title }}</h1>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="col-lg-3 col-xl-2 sponsors__all"
                v-for="sponsor in subsection.collections[0].pages"
                v-if="sponsor.fields.main_sponsor.value != 1"
              >
                <div class="sponsors__block">
                  <a
                    :href="sponsor.fields.link.value || ''"
                    class="img__block"
                    target="_blank"
                  >
                    <img
                      v-if="
                        sponsor.fields.logo && sponsor.fields.logo.value.length
                      "
                      :src="'/uploads/' + sponsor.fields.logo.value[0]"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--
			 PARTENAIRES - page "Club2012"
		-->
    <div v-else-if="subsection.type == 'partner_page'" class="row gsap-fade-up">
      <div class="col-md-8">
        <div class="content" v-html="subsection.content"></div>
      </div>
      <div class="col-md-4" v-if="mainSponsors.length > 0">
        <div class="row">
          <div
            class="col-xl-6"
            v-for="sponsor in mainSponsors"
            v-if="sponsor.fields.main_sponsor.value == 1"
          >
            <a
              v-if="sponsor.fields.logo && sponsor.fields.logo.value.length"
              :href="sponsor.fields.link.value || ''"
              target="_blank"
              class="logo"
            >
              <img :src="'/uploads/' + sponsor.fields.logo.value[0]" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--
			 PARTENAIRES - page "Club2012"
		-->
    <div v-else-if="subsection.type == 'products'" class="row">
      <div class="col">
        <div class="row gsap-fade">
          <div class="col">
            <div class="products__contact" v-html="subsection.content"></div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-6 col-lg-4 gsap-fade-up"
            v-for="product in subsection.collections[0].pages"
          >
            <div class="product">
              <swiper :options="sliderOptions" class="product__gallery">
                <swiper-slide
                  v-for="(img, index) in product.fields.gallery.value"
                  :key="index"
                >
                  <img class="image" :src="medium(img)" alt="" />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>

              <p class="product__name">{{ product.title }}</p>
              <div class="product__size">
                <span :class="{ disabled: product.fields.s_size.value == 1 }"
                  >S</span
                >
                <span :class="{ disabled: product.fields.m_size.value == 1 }"
                  >M</span
                >
                <span :class="{ disabled: product.fields.l_size.value == 1 }"
                  >L</span
                >
                <span :class="{ disabled: product.fields.xl_size.value == 1 }"
                  >XL</span
                >
              </div>
              <hr />
              <p class="product__price">CHF {{ product.fields.price.value }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <teams-component
      v-else-if="section.type == 'teams'"
      :section="section"
    ></teams-component>
  </section>
</template>

<script>
import _find from "lodash/find";
import { mapState } from "vuex";
import NextMatches from "./component-parts/next-matches-component";
import HighlightNews from "./component-parts/highlight-news-component";
import Teams from "./teams/teams-component";
import constants from "../constants.js";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "SubSectionComponent",
  components: {
    "next-matches-component": NextMatches,
    "highlight-news-component": HighlightNews,
    "teams-component": Teams,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      subsection: {},
      sections: [],
      section: {},
      teamSection: {},
      stadium: null,
      mainSponsors: [],
      allNews: {},
      allNewsWithMonths: {},
      playerInfoOpen: false,
      sliderOptions: {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
        },
      },
      params: {
        title: "",
        description: "",
        descriptionTwitter: "",
        titleTwitter: "",
        descriptionFacebook: "",
        titleFacebook: "",
        image: "",
        imageTwitter: "",
        imageFacebook: "",
        linkCanonical: "",
      },
      selectedStadiumInfo: {},
      map: {
        center: { lat: 46.198423, lng: 6.157383 },
        zoom: 16,
        tilt: 0,
        options: {
          styles: constants.mapStyle,
          scrollwheel: false,
          navigationControl: false,
          mapTypeControl: false,
          scaleControl: false,
        },
        marker: {
          center: { lat: 46.198423, lng: 6.157383 },
          icon: "",
        },
      },
    };
  },
  watch: {
    $route: function() {
      this.$root.juniorsSubCategory = null;
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
  head: {
    title: function() {
      return {
        inner: this.params.title,
        separator: " ",
      };
    },
    meta: function() {
      return [
        { n: "description", c: this.params.description },
        { n: "keywords", c: this.params.keywords },
        { n: "twitter:title", c: this.params.titleTwitter },
        { n: "twitter:description", c: this.params.descriptionTwitter },
        { n: "twitter:image", c: `${url}/uploads/${this.params.imageTwitter}` },
        { p: "og:title", c: this.params.titleFacebook },
        { p: "og:description", c: this.params.descriptionFacebook },
        { p: "og:image", c: `${url}/uploads/${this.params.imageFacebook}` },
        { p: "og:url", h: `${url}` },
      ];
    },
    link: function() {
      return [{ r: "canonical", h: this.params.linkCanonical }];
    },
  },
  methods: {
    fetchData() {
      const section = _find(this.allSections, {
        slug: this.$route.params.sectionSlug,
      });
      this.section = section;

      // Check if section is teams
      if (section.type == "teams") {
        // Get Team Sections
        const teamSection = _find(this.allSections, {
          slug: this.$route.params.sectionSlug,
        });
        this.teamSection = teamSection;
      } else {
        const subsection = _find(this.allSections, {
          slug: this.$route.params.subsectionSlug,
        });
        this.subsection = subsection;

        if (this.$route.params.sectionSlug == "partenaires") {
          this.mainSponsors = this.subsection.collections[0].pages;
        }

        // Get first stadium
        if (subsection && this.subsection.type == "infrastructure") {
          this.getFirstStadium();
        }
        this.params = this.formatMeta(this.subsection);
        if (subsection && subsection.type == "contact") {
          let firstStadiumLocation = this.subsection.collections[0].pages[0];
          this.selectedStadiumInfo = firstStadiumLocation;
        }
      }

      this.$nextTick(() => {
        this.$emit("updateHead");
        this.fade(".gsap-fade");
        this.fadeUp(".gsap-fade-up");

        $(".grid").masonry({
          // options
          itemSelector: ".grid-item",
          columnWidth: ".grid-sizer",
          percentPosition: true,
        });
        window.scroll(0, 0);
      });
    },
    getFirstStadium() {
      this.stadium = this.subsection.collections[0].pages[0];
      this.$nextTick(() => {
        this.fadeUp(".infrastructure .background-white > div");
      });
    },
    viewStadium(page) {
      this.stadium = page;
      this.fade(".gsap-fade-on-change");
      window.scroll(0, 0);
      this.$refs.mySwiper.swiper.slideTo(0);
    },
    handleNews(val) {
      this.allNews = val;
    },
    handleNewsMonths(val) {
      this.allNewsWithMonths = val;
    },
    getStadiumInfo(stadium) {
      this.selectedStadiumInfo = stadium;
      $("html, body").animate(
        {
          scrollTop: $(".contact__stadium").offset().top - 100,
        },
        500
      );
      TweenMax.staggerFromTo(
        ".contact__stadium-description",
        0.7,
        { opacity: 0, y: 15 },
        { opacity: 1, y: 0 },
        0.2
      );
    },

    // Animations
    fadeUp(el) {
      TweenMax.staggerFromTo(
        el,
        0.7,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0 },
        0.2
      );
    },
    fade(el) {
      TweenMax.staggerFromTo(el, 0.7, { opacity: 0 }, { opacity: 1 }, 0.2);
    },
  },
  computed: {
    ...mapState({
      allSections: "allSections",
      teams: "teams",
      teamsWithCategories: "teamsWithCategories",
    }),
    teamSubsection() {
      return _find(this.teamsWithCategories, {
        slug: this.$route.params.subsectionSlug,
      });
    },
    newsCorrectOrder() {
      return Object.keys(this.allNewsWithMonths).reverse();
    },
  },
};
</script>
